import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { formatCurrency } from '../../helpers/payDuties';

function popover(title, body, link) {
  return (
    <Popover id='popover-bottom' bsPrefix='popover paymentDuties in'>
      <Popover.Title as='h3'>{title}</Popover.Title>
      <Popover.Content>{body}{link}</Popover.Content>
    </Popover>);
}

// TODO: Must get all payments values from BE and not hardcoded in the FE
const PayDetails = ({ parcelData, payType, inspection, t }) => {
  const { duties, inspectionText } = parcelData;

  return (
    <div className='animated fadeIn'>
      <div className='section'>
        <div className='details '>
          <label>
            פירוט חישוב הסכום לתשלום:
          </label>
        </div>
      </div>
      {!payType &&
        <div className='section'>
          <div className='details '>
            <label>
              שווי הפריט (FOB):
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover('ערך המוצר במט״ח (FOB)', 'ערך המוצר/טובין כפי שהוצהר על גבי השטר מטען / הספק.')}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>

            <div className='value'>
              {formatCurrency(duties.usd.price, 'USD')}
            </div>
          </div>
        </div>
      }
      {!payType &&
        <div className='section'>
          <div className='details '>
            <label>
              שווי מכסי (CIF):
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'ערך לצרכי מכס (CIF)',
                  'עלות המשלוח הכוללת את שווי הפריט/הטובין + ערך ההובלה + עלות הביטוח במידה וקיים'
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.usd.cifValue, 'USD')}
            </div>
          </div>
        </div>
      }
      {!payType &&
        <div className='section'>
          <div className='details '>
            {/* TODO this link http://62.219.95.10/CurrRates/Rools.pdf is not work!!!! */}
            <label>
              המרה לשקלים:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'המרה לשקלים',
                  'המרה לשקלים לפי כללי המכס (חישוב מחיר נקוב במטבע חוץ) התשמ״ט-1989. לפרטים נוספים:',
                  <a target='_blank' rel='noopener noreferrer' href='http://62.219.95.10/CurrRates/Rools.pdf'> לחצו כאן </a>
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.cifValue, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {!payType &&
        <div className='section'>
          <div className='details '>
            <label>
              מע״מ:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'מע״מ - מס ערך מוסף',
                  'מס המוטל על העסקה בישראל, יבוא טובין ומתן שירותים. המס מחושב על פי ערך ה-CIF ומיסים. התשלום מועבר במלואו למכס.'
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.vat, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {!payType && duties.localCurrency.payments.customComputerFullCommission !== '0.00' &&
        <div className='section'>
          <div className='details '>
            <label>
              מכס - אגרת מחשב:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'אגרת מחשב עבור מכס ישראל',
                  'החל מתאריך ה 14 לינואר 2018, המכס גובה אגרת מחשב של 36 שח עבור חבילות בערך של מעל $1000. התשלום מועבר במלואו למכס.',
                  <a href='http://www.exelot.com' target='_blank' rel='noopener noreferrer'> לנוסח ההוראה באתר המכס </a>
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.customComputerFullCommission, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {!payType && duties.localCurrency.payments.customComputerCommission !== '0.00' &&
        <div className='section'>
          <div className='details '>
            <label>
              מכס - אגרת מחשב:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'אגרת מחשב עבור מכס ישראל',
                  'החל מתאריך ה 14 לינואר 2018, המכס גובה אגרת מחשב של 18 שח עבור חבילות בערך של עד $1000. התשלום מועבר במלואו למכס.'
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.customComputerCommission, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {!payType && duties.localCurrency.payments.customSecurityCommission !== '0.00' &&
        <div className='section'>
          <div className='details '>
            <label>
              מכס - אגרת בטחון:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'אגרת בטחון עבור מכס ישראל',
                  'החל מתאריך ה 14 לינואר 2018, המכס גובה אגרת בטחון על כל חבילה שערכה מעל $500. התשלום מועבר במלואו למכס.'
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.customSecurityCommission, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {!payType && duties.localCurrency.payments.exelotCommission !== '0.00' &&
        <div className='section'>
          <div className='details '>
            <label>
            עמלת טיפול:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  'עמלת טיפול',
                  'עמלת טיפול בגביית המיסים, הוצאות סליקה, תקשורת ועבודה מול המכס .עמלה זאת נמוכה משמעותית מהעמלה שגובים שאר הגורמים המשלחים בשוק ומיועדת לכיסוי עלויות'
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.exelotCommission, duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      {payType === 'inspection' && duties.localCurrency.payments.inspectionCommission[inspection] !== 0 &&
        <div className='section'>
          <div className='details '>
            <label>
              {t(inspectionText.inspectionFeeName)}:
              <OverlayTrigger
                trigger='hover'
                placement='bottom'
                overlay={popover(
                  t(inspectionText.inspectionFeeName),
                  t(inspectionText.inpectionFeeDescription)
                )}
              >
                <i
                  className='glyphicon glyphicon-info-sign'
                />
              </OverlayTrigger>
            </label>
            <div className='value'>
              {formatCurrency(duties.localCurrency.payments.inspectionCommission[inspection], duties.localCurrency.currencyCode)}
            </div>
          </div>
        </div>
      }
      <div className='section'>
        <div className='details bold '>
          <label>
            לתשלום:
          </label>
          <div className='value'>
            {formatCurrency(duties.localCurrency.payments.total, duties.localCurrency.currencyCode)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(PayDetails);